import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// SVG対応SectionDividerコンポーネント
export const SectionDivider = ({ title }) => {
  if (!title) return null;
  
  return (
    <div className="text-center py-8 md:py-12 ml-0 md:ml-40" style={{backgroundColor: '#fffbe0'}}>
      <img 
        src={`/images/sections/${title}.svg`}
        alt={title}
        className="mx-auto section-divider-svg"
        style={{
          height: 'auto',
          maxWidth: '100%'
        }}
      />
    </div>
  );
};

export default function Layout({ children }) {
  const [isNavHovered, setIsNavHovered] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [showDropup, setShowDropup] = useState(false);
  
  const navigate = useNavigate();
  const location = useLocation();

  // ナビゲーション関数
  const handleNavClick = (path) => {
    navigate(path);
  };

  // 現在のページを判定
  const getCurrentPage = () => {
    const path = location.pathname;
    if (path === '/') return 'index';
    return path.substring(1); // '/about' -> 'about'
  };

  const currentPage = getCurrentPage();

  return (
    <div className="min-h-screen" style={{backgroundColor: '#ffe5beff'}}>
      <div className="min-h-screen relative">
        
        {/* PCサイドナビ（768px以上で表示） */}
        <aside
          className={`hidden md:block absolute left-8 top-0 w-32 z-10 h-full shadow-sm transition-all duration-300`}
          style={{
            backgroundColor: isNavHovered ? '#FFA500' : 'rgba(255, 165, 0, 0.2)',
            backdropFilter: 'blur(4px)'
          }}
          onMouseEnter={() => setIsNavHovered(true)}
          onMouseLeave={() => setIsNavHovered(false)}
        >
          <div className="sticky top-0 h-screen flex flex-col">
            
            {/* ロゴエリア */}
            <div className="p-4">
              <button onClick={() => handleNavClick('/')} className="block w-full">
                <div className="text-center">
                  <div style={{
                    width: '100px',
                    height: '100px',
                    backgroundColor: 'white',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 8px auto'
                  }}>
                    <img 
                      src="/images/logo/logo.svg" 
                      alt="立石農園ロゴ" 
                      style={{width: '80px', height: '80px'}}
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.parentElement.style.background = 'linear-gradient(135deg, #ef4444, #f97316)';
                        e.target.nextElementSibling.style.display = 'block';
                      }}
                    />
                    <span style={{
                      color: 'white', 
                      fontWeight: 'bold', 
                      fontSize: '24px',
                      display: 'none'
                    }}>立</span>
                  </div>
                </div>
              </button>
            </div>

            {/* ナビゲーション */}
            <nav className="flex-1 py-4">
              <div className="space-y-2 px-2">
                {/* 立石農園について */}
                <button
                  onClick={() => handleNavClick('/about')}
                  className={`flex flex-col items-center px-2 py-3 rounded-lg text-xs font-medium transition-all duration-200 w-full ${
                    currentPage === 'about' || hoveredItem === 'about' ? '' : 'text-stone-800'
                  }`}
                  style={(currentPage === 'about' || hoveredItem === 'about') ? {backgroundColor: '#8b4513', color: '#fff'} : {}}
                  onMouseEnter={() => setHoveredItem('about')}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <img
                    src="/images/nouen.svg"
                    alt="農園"
                    className="w-5 h-5 mb-1"
                    style={(currentPage === 'about' || hoveredItem === 'about') ? {filter: 'brightness(0) invert(1)'} : {}}
                  />
                  <span className="text-center leading-tight">立石農園について</span>
                </button>

                {/* 農作物 */}
                <button
                  onClick={() => handleNavClick('/products')}
                  className={`flex flex-col items-center px-2 py-3 rounded-lg text-xs font-medium transition-all duration-200 w-full ${
                    currentPage === 'products' || hoveredItem === 'products' ? '' : 'text-stone-800'
                  }`}
                  style={(currentPage === 'products' || hoveredItem === 'products') ? {backgroundColor: '#8b4513', color: '#fff'} : {}}
                  onMouseEnter={() => setHoveredItem('products')}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <img
                    src="/images/leaf.svg"
                    alt="葉っぱ"
                    className="w-5 h-5 mb-1"
                    style={(currentPage === 'products' || hoveredItem === 'products') ? {filter: 'brightness(0) invert(1)'} : {}}
                  />
                  <span className="text-center leading-tight">農作物</span>
                </button>

                {/* お知らせ・受賞歴など */}
                <button
                  onClick={() => handleNavClick('/news')}
                  className={`flex flex-col items-center px-2 py-3 rounded-lg text-xs font-medium transition-all duration-200 w-full ${
                    currentPage === 'news' || hoveredItem === 'news' ? '' : 'text-stone-800'
                  }`}
                  style={(currentPage === 'news' || hoveredItem === 'news') ? {backgroundColor: '#8b4513', color: '#fff'} : {}}
                  onMouseEnter={() => setHoveredItem('news')}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <svg className="w-5 h-5 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 713.138-3.138z" />
                  </svg>
                  <span className="text-center leading-tight">お知らせ・受賞歴など</span>
                </button>

                {/* お問い合わせ */}
                <button
                  onClick={() => handleNavClick('/contact')}
                  className={`flex flex-col items-center px-2 py-3 rounded-lg text-xs font-medium transition-all duration-200 w-full ${
                    currentPage === 'contact' || hoveredItem === 'contact' ? '' : 'text-stone-800'
                  }`}
                  style={(currentPage === 'contact' || hoveredItem === 'contact') ? {backgroundColor: '#8b4513', color: '#fff'} : {}}
                  onMouseEnter={() => setHoveredItem('contact')}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <svg className="w-5 h-5 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  <span className="text-center leading-tight">お問い合わせ</span>
                </button>

                {/* ダウンロード */}
                <button
                  onClick={() => handleNavClick('/downloads')}
                  className={`flex flex-col items-center px-2 py-3 rounded-lg text-xs font-medium transition-all duration-200 w-full ${
                    currentPage === 'downloads' || hoveredItem === 'downloads' ? '' : 'text-stone-800'
                  }`}
                  style={(currentPage === 'downloads' || hoveredItem === 'downloads') ? {backgroundColor: '#8b4513', color: '#fff'} : {}}
                  onMouseEnter={() => setHoveredItem('downloads')}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <svg className="w-5 h-5 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <span className="text-center leading-tight">ダウンロード</span>
                </button>
              </div>
            </nav>
          </div>
        </aside>

        {/* スマホ下部タブナビ（768px以下で表示） */}
        <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-stone-200 z-20">
          {/* その他ドロップアップメニュー */}
          {showDropup && (
            <div className="absolute bottom-full left-0 right-0 bg-white border-t border-stone-200 shadow-lg">
              <div className="flex">
                <button
                  onClick={() => {
                    handleNavClick('/contact');
                    setShowDropup(false);
                  }}
                  className="flex-1 flex flex-col items-center py-3 px-1 transition-colors text-stone-600"
                  style={{':hover': {color: '#8b4513'}}}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#8b4513'}
                  onMouseLeave={(e) => e.currentTarget.style.color = ''}
                >
                  <svg className="w-6 h-6 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  <span className="text-xs font-medium">お問い合わせ</span>
                </button>
                <button
                  onClick={() => {
                    handleNavClick('/downloads');
                    setShowDropup(false);
                  }}
                  className="flex-1 flex flex-col items-center py-3 px-1 transition-colors text-stone-600"
                  onMouseEnter={(e) => e.currentTarget.style.color = '#8b4513'}
                  onMouseLeave={(e) => e.currentTarget.style.color = ''}
                >
                  <svg className="w-6 h-6 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <span className="text-xs font-medium">ダウンロード</span>
                </button>
              </div>
            </div>
          )}

          <div className="flex">
            {/* ホーム */}
            <button
              onClick={() => handleNavClick('/')}
              className={`flex-1 flex flex-col items-center py-2 px-1 transition-colors ${
                currentPage === 'index' ? '' : 'text-stone-600'
              }`}
              style={currentPage === 'index' ? {backgroundColor: '#8b4513', color: '#fff'} : {}}
            >
              <svg className="w-6 h-6 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>
              <span className="text-xs font-medium">ホーム</span>
            </button>

            {/* 立石農園について */}
            <button
              onClick={() => handleNavClick('/about')}
              className={`flex-1 flex flex-col items-center py-2 px-1 transition-colors ${
                currentPage === 'about' ? '' : 'text-stone-600'
              }`}
              style={currentPage === 'about' ? {backgroundColor: '#8b4513', color: '#fff'} : {}}
            >
              <img
                src="/images/nouen.svg"
                alt="農園"
                className="w-6 h-6 mb-1"
                style={currentPage === 'about' ? {filter: 'brightness(0) invert(1)'} : {}}
              />
              <span className="text-xs font-medium">立石農園について</span>
            </button>

            {/* 農作物 */}
            <button
              onClick={() => handleNavClick('/products')}
              className={`flex-1 flex flex-col items-center py-2 px-1 transition-colors ${
                currentPage === 'products' ? '' : 'text-stone-600'
              }`}
              style={currentPage === 'products' ? {backgroundColor: '#8b4513', color: '#fff'} : {}}
            >
              <img
                src="/images/leaf.svg"
                alt="葉っぱ"
                className="w-6 h-6 mb-1"
                style={currentPage === 'products' ? {filter: 'brightness(0) invert(1)'} : {}}
              />
              <span className="text-xs font-medium">農作物</span>
            </button>

            {/* ニュース */}
            <button
              onClick={() => handleNavClick('/news')}
              className={`flex-1 flex flex-col items-center py-2 px-1 transition-colors ${
                currentPage === 'news' ? '' : 'text-stone-600'
              }`}
              style={currentPage === 'news' ? {backgroundColor: '#8b4513', color: '#fff'} : {}}
            >
              <svg className="w-6 h-6 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
              </svg>
              <span className="text-xs font-medium">ニュース</span>
            </button>

            {/* その他 */}
            <button
              onClick={() => setShowDropup(!showDropup)}
              className={`flex-1 flex flex-col items-center py-2 px-1 transition-colors ${
                showDropup ? '' : 'text-stone-600'
              }`}
              style={showDropup ? {backgroundColor: '#8b4513', color: '#fff'} : {}}
            >
              <svg className="w-6 h-6 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z" />
              </svg>
              <span className="text-xs font-medium">その他</span>
            </button>
          </div>
        </nav>

        {/* メインコンテンツエリア：childrenをそのまま表示 */}
        <main className="w-full min-h-screen" style={{backgroundColor: '#ffe5beff'}}>
          {children}
        </main>

        {/* フッター：クリーム色背景、スマホ版のみ下部ナビ分の余白 */}
        <footer style={{backgroundColor: '#fffbe0', color: '#8b4513'}} className="pb-20 md:pb-0">
          <div className="p-6 lg:p-12 ml-0 md:ml-40">
            
            {/* PC版フッター（768px以上） */}
            <div className="hidden md:block max-w-4xl mx-auto">
              {/* サイトマップとInstagram/通販（3列構成） */}
              <div className="grid grid-cols-3 mb-8">
                
                {/* 1. サイトマップ（左列） */}
                <div>
                  <h4 className="text-base font-bold mb-3 text-center" style={{color: '#8b4513'}}>サイトマップ</h4>
                  <nav className="space-y-1">
                    <button onClick={() => handleNavClick('/')} className="block w-full text-center py-1 rounded-lg transition-colors text-sm hover:underline" style={{color: '#8b4513'}}>
                      ホーム
                    </button>
                    <button onClick={() => handleNavClick('/about')} className="block w-full text-center py-1 rounded-lg transition-colors text-sm hover:underline" style={{color: '#8b4513'}}>
                      立石農園について
                    </button>
                    <button onClick={() => handleNavClick('/others')} className="block w-full text-center py-1 rounded-lg transition-colors text-sm hover:underline" style={{color: '#8b4513'}}>
                      栽培作物
                    </button>
                    <button onClick={() => handleNavClick('/others')} className="block w-full text-center py-1 rounded-lg transition-colors text-sm hover:underline" style={{color: '#8b4513'}}>
                      実績・受賞歴
                    </button>
                    <button onClick={() => handleNavClick('/others')} className="block w-full text-center py-1 rounded-lg transition-colors text-sm hover:underline" style={{color: '#8b4513'}}>
                      お問い合わせ
                    </button>
                    <button onClick={() => handleNavClick('/others')} className="block w-full text-center py-1 rounded-lg transition-colors text-sm hover:underline" style={{color: '#8b4513'}}>
                      その他
                    </button>
                    <button onClick={() => handleNavClick('/others')} className="block w-full text-center py-1 rounded-lg transition-colors text-sm hover:underline" style={{color: '#8b4513'}}>
                      プライバシーポリシー
                    </button>
                  </nav>
                </div>

                {/* 2. ロゴ・紹介文・著作権（中央列） */}
                <div className="flex flex-col items-center justify-center space-y-4">
                  {/* ロゴ */}
                  <img 
                    src="/images/logo/logo.svg" 
                    alt="立石農園ロゴ" 
                    style={{width: '180px', height: '180px'}}
                  />
                  
                  {/* 紹介文（2行） */}
                  <div className="text-center">
                    <p style={{color: '#8b4513'}} className="leading-relaxed text-xs">
                      中山間地域から新しい価値を創造する若手農業集団。<br />
                      科学的アプローチと最新技術で持続可能な農業を実践し、<br />
                      20代中心のチームで地域農業の未来を切り開いています。
                    </p>
                  </div>
                  
                  {/* 著作権 */}
                  <div className="text-center">
                    <p style={{color: '#8b4513'}} className="text-xs">
                      &copy; 2025 立石農園. All rights reserved.
                    </p>
                  </div>
                </div>

                {/* 3. Instagram + 通販（右列、縦並び） */}
                <div className="space-y-4">
                  
                  {/* Instagram */}
                  <div>
                    <h4 className="text-base font-bold mb-3 text-center" style={{color: '#8b4513'}}>Instagram</h4>
                    <div className="text-center">
                      <button 
                        onClick={() => window.open('https://www.instagram.com/08._.tate/', '_blank')}
                        className="text-white px-6 py-2 rounded-lg font-bold transition-colors text-xs"
                        style={{background: 'linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%)'}}
                      >
                        Instagramを見る
                      </button>
                    </div>
                  </div>

                  {/* 通販 */}
                  <div>
                    <h4 className="text-base font-bold mb-3 text-center" style={{color: '#8b4513'}}>通販</h4>
                    <div className="flex flex-col items-center space-y-2">
                      <a
                        href="https://www.tabechoku.com/producers/3078345?srsltid=AfmBOorXuP8OB-ehEl8b8-qLtXW0qcL4L0KjoOdCkAqzEfyPN5Yo2oGy"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg font-bold transition-colors text-xs"
                      >
                        食べチョク
                      </a>
                      <a
                        href="https://jp.mercari.com/user/profile/819884723"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block bg-red-500 hover:bg-red-600 text-white px-6 py-2 rounded-lg font-bold transition-colors text-xs"
                      >
                        メルカリ
                      </a>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            {/* スマホ版フッター（768px以下） */}
            <div className="md:hidden">
              {/* 上段：サイトマップ（左）+ Instagram/通販（右）の2列を中央寄せ */}
              <div className="max-w-sm mx-auto">
                <div className="grid grid-cols-2 gap-6 mb-6">
                  
                  {/* サイトマップ（左） */}
                  <div>
                    <h4 className="text-sm font-bold mb-3 text-center" style={{color: '#8b4513'}}>サイトマップ</h4>
                    <nav className="space-y-1 text-center">
                      <button onClick={() => handleNavClick('/')} className="block w-full py-1 text-xs hover:underline" style={{color: '#8b4513'}}>
                        ホーム
                      </button>
                      <button onClick={() => handleNavClick('/about')} className="block w-full py-1 text-xs hover:underline" style={{color: '#8b4513'}}>
                        立石農園について
                      </button>
                      <button onClick={() => handleNavClick('/others')} className="block w-full py-1 text-xs hover:underline" style={{color: '#8b4513'}}>
                        栽培作物
                      </button>
                      <button onClick={() => handleNavClick('/others')} className="block w-full py-1 text-xs hover:underline" style={{color: '#8b4513'}}>
                        実績・受賞歴
                      </button>
                      <button onClick={() => handleNavClick('/others')} className="block w-full py-1 text-xs hover:underline" style={{color: '#8b4513'}}>
                        お問い合わせ
                      </button>
                      <button onClick={() => handleNavClick('/others')} className="block w-full py-1 text-xs hover:underline" style={{color: '#8b4513'}}>
                        その他
                      </button>
                      <button onClick={() => handleNavClick('/others')} className="block w-full py-1 text-xs hover:underline" style={{color: '#8b4513'}}>
                        プライバシーポリシー
                      </button>
                    </nav>
                  </div>

                  {/* Instagram + 通販（右） */}
                  <div className="space-y-3">
                    
                    {/* Instagram */}
                    <div>
                      <h4 className="text-sm font-bold mb-2 text-center" style={{color: '#8b4513'}}>Instagram</h4>
                      <button 
                        onClick={() => window.open('https://www.instagram.com/08._.tate/', '_blank')}
                        className="text-white px-4 py-2 rounded-lg font-bold text-xs w-full"
                        style={{background: 'linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%)'}}
                      >
                        Instagramを見る
                      </button>
                    </div>

                    {/* 通販 */}
                    <div>
                      <h4 className="text-sm font-bold mb-2 text-center" style={{color: '#8b4513'}}>通販</h4>
                      <div className="space-y-2">
                        <a
                          href="https://www.tabechoku.com/producers/3078345?srsltid=AfmBOorXuP8OB-ehEl8b8-qLtXW0qcL4L0KjoOdCkAqzEfyPN5Yo2oGy"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="block bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg font-bold text-xs w-full text-center"
                        >
                          食べチョク
                        </a>
                        <a
                          href="https://jp.mercari.com/user/profile/819884723"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="block bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg font-bold text-xs w-full text-center"
                        >
                          メルカリ
                        </a>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              {/* 下段：ロゴ + 紹介文 + 著作権（縦並び中央寄せ） */}
              <div className="text-center space-y-4">
                {/* ロゴ */}
                <img 
                  src="/images/logo/logo.svg" 
                  alt="立石農園ロゴ" 
                  className="mx-auto"
                  style={{width: '120px', height: '120px'}}
                />
                
                {/* 紹介文（1行） */}
                <p style={{color: '#8b4513'}} className="text-xs leading-relaxed">
                  中山間地域から新しい価値を創造する若手農業集団
                </p>
                
                {/* 著作権 */}
                <p style={{color: '#8b4513'}} className="text-xs">
                  &copy; 2025 立石農園. All rights reserved.
                </p>
              </div>
            </div>

          </div>
        </footer>

      </div>
    </div>
  );
}